module.exports = __webpack_public_path__ + "img/BannerNew.669c1330.png";